import { Component, OnInit, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location, getLocaleMonthNames } from '@angular/common';
import { ContactService } from '../../services/contact.service';

import { HttpClient } from '@angular/common/http';


//pak vse smazat, jen pro rzchlost to tu je
/*import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";
*/
type concernType = Array<{idPost: string, idContact: string, name: string, surname: string, nick: string, state: number, profileImage: string}>;

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
  providers: [ContactService]
})
export class ContactComponent implements OnInit {
  isEdited: boolean = false;
  selecedPost: number = -1;
  editedPost = {
    "id": "",
    "idUser": localStorage.getItem("idUser"),
    "textPost": "",
    "place": "",
    "settings": 0, 
    "postDate": null,
    "postImage": "",
  }
  editedConcerns: concernType = [];
  editedConcernsChanges: concernType = [];
  newProfileImage: string = "";
  
  newPost = { 
    postImage: "",
    textPost: "",
    place: "",
    settings: 0,
    postDate: new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + (new Date().getDate() + 1)).slice(-2) + "T" + ("0" + new Date().toLocaleTimeString().slice(0,-3)).slice(-5)
  };

  editedContact = {
    id: "", 
    name: "", 
    surname: "", 
    nick: "", 
    degreeBegin: "",
    degreeEnd: "",
    note: "", 
    birthday: "",
    telephone: "", 
    email: "",
    adress: "",
    profileImage: "",
    idGroup: "",      
    state: 0
  };

  constructor(private route: ActivatedRoute, private contactService: ContactService, private location: Location,
     private http: HttpClient, private elem: ElementRef) {
    route.params.subscribe(val => {
      this.reload();
      this.ngOnInit();
    });
   }

  ngOnInit() {
    this.contactService.idContact = this.route.snapshot.paramMap.get('id');
    this.editedContact = this.contactService.getContact();
    this.contactService.getPosts();
    this.contactService.getContacts();
    this.contactService.getContactGroups();
  }

  reload(){
    this.newPost.postImage = "",
    this.newPost.textPost = "",
    this.newPost.place = "",
    this.newPost.settings = 0,
    this.newPost.postDate = new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + (new Date().getDate() + 1)).slice(-2) + "T" + ("0" + new Date().toLocaleTimeString().slice(0,-3)).slice(-5)
    this.contactService.newConcern = [];
    this.contactService.fromPost = 0;
    this.contactService.postCount = 20;
  }

  editContact(){
    this.editedContact.id = this.contactService.contact.id;
    this.editedContact.name = this.contactService.contact.name;
    this.editedContact.surname = this.contactService.contact.surname;
    this.editedContact.nick = this.contactService.contact.nick;
    this.editedContact.degreeBegin = this.contactService.contact.degreeBegin;
    this.editedContact.degreeEnd = this.contactService.contact.degreeEnd;
    this.editedContact.telephone = this.contactService.contact.telephone;
    this.editedContact.email = this.contactService.contact.email;
    this.editedContact.note = this.contactService.contact.note;
    this.editedContact.birthday = this.contactService.contact.birthday;
    this.editedContact.adress = this.contactService.contact.adress;
    this.editedContact.profileImage = this.contactService.contact.profileImage;
    this.editedContact.state = this.contactService.contact.state;
    this.editedContact.idGroup = this.contactService.contact.idGroup;
  }

  updateContact(){
    this.contactService.updateContact(this.editedContact);
  }

  addPost(){
    if(this.contactService.addPost(this.newPost) == true){
      this.newPost.textPost = "";
      this.newPost.postImage = "";
      this.newPost.place = "";
      this.newPost.postDate = new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + (new Date().getDate())).slice(-2) + "T" + ("0" + new Date().toLocaleTimeString().slice(0,-3)).slice(-5);
    }
  }

  selectPost(i){
    this.selecedPost = i;

    this.editedPost.id = this.contactService.posts[i].id;
    this.editedPost.textPost = this.contactService.posts[i].textPost;
    this.editedPost.place = this.contactService.posts[i].place;
    this.editedPost.settings = this.contactService.posts[i].settings;
    this.editedPost.postDate = this.contactService.posts[i].postDate;
    this.editedPost.postDate = this.editedPost.postDate.replace(' ','T');
    this.editedPost.postImage = this.contactService.posts[i].postImage;

    this.editedConcerns = [];
    this.editedConcernsChanges = [];
    for(let j = 0; j < this.contactService.posts[i].people.length; j++){
      let concernParams = {
        idContact: this.contactService.posts[i].people[j].idContact,
        idPost: this.contactService.posts[i].people[j].idPost,
        name: this.contactService.posts[i].people[j].name,
        surname: this.contactService.posts[i].people[j].surname,
        nick: this.contactService.posts[i].people[j].nick,
        profileImage: this.contactService.posts[i].people[j].profileImage,
        state: 0
      }
      this.editedConcernsChanges.push(concernParams);
      this.editedConcerns.push(concernParams);
    }
  }

  updatePost(){
    this.contactService.updatePost(this.editedPost,this.editedConcernsChanges,this.selecedPost);
  }

  removeContact(id){
    this.contactService.removeContact(id);
    
  }
  removePost(i, id){
    this.contactService.removePost(i, id);
    
  }

  addContactToPost(contactID){
    this.contactService.addtoConcern(contactID);
  }

  deleteConcern(contactID){
    this.contactService.deleteConcern(contactID);
  }

  addContactToEditedPost(contactID){
    let isAdded = false;
    let concern = {
      "idPost": this.editedPost.id,
      "idContact": "",
      "name": "",
      "surname": "",
      "nick": "",
      "profileImage": "",
      "state": 1
    }

    for(let i = 0; i < this.editedConcerns.length; i++){
      if(contactID == this.editedConcerns[i].idContact) isAdded = true;
    }

    for(let i = 0; i < this.editedConcernsChanges.length; i++){
      if(contactID == this.editedConcernsChanges[i].idContact && isAdded == false){
        isAdded = true;
        this.editedConcernsChanges[i].state = this.editedConcernsChanges[i].state + 1;
        if(this.editedConcernsChanges[i].state == 0){
          this.editedConcerns.push(this.editedConcernsChanges[i]); 
        }
      } 
    }

    if(isAdded == false && contactID != ""){
      for(let i = 0; i < this.contactService.mycontacts.length; i++){
        if(contactID == this.contactService.mycontacts[i].id){
          concern.idContact = contactID;
          concern.name = this.contactService.mycontacts[i].name;
          concern.surname = this.contactService.mycontacts[i].surname;
          concern.nick = this.contactService.mycontacts[i].nick;
          concern.profileImage = this.contactService.mycontacts[i].profileImage;
          this.editedConcerns.push(concern);
          this.editedConcernsChanges.push(concern);
          break;
        }
      }
      
    }

  }

  deleteFromEditedPost(contactID){
    
    for(let i = 0; i < this.editedConcernsChanges.length; i++){
      if(contactID == this.editedConcernsChanges[i].idContact){
        this.editedConcernsChanges[i].state = this.editedConcernsChanges[i].state -1;
        break;
      }
    }
    for(let i = 0; i < this.editedConcerns.length; i++){
      if(contactID == this.editedConcerns[i].idContact){
        this.editedConcerns.splice(i,1);
      }
    }
  }

  morePosts(){
    this.contactService.fromPost += this.contactService.postCount;
    this.contactService.getPosts();
  }


}



// WEBPACK FOOTER //
// ./src/app/components/contact/contact.component.ts